import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Max

  <span style="color:#85c1dc;">**FI:**</span>
  Max

  <span style="color:#85c1dc;">**RU:**</span>
  Мах
*/
/* @__NO_SIDE_EFFECTS__ */
const m300 = msg(
  mf`Max`,
  mf`Max`,
  mf`Мах`,
)

export { m300 as 'w.module.filter_bar.max' }